export const CARDS = [
  {
    id: 1,
    src: "./images/cards/clubs_2.png",
    isSelected: false,
    value: 2,
    points: 1
  },
  {
    id: 2,
    src: "./images/cards/clubs_3.png",
    isSelected: false,
    value: 3,
    points: 0
  },
  {
    id: 3,
    src: "./images/cards/clubs_4.png",
    isSelected: false,
    value: 4,
    points: 0
  },
  {
    id: 4,
    src: "./images/cards/clubs_5.png",
    isSelected: false,
    value: 5,
    points: 0
  },
  {
    id: 5,
    src: "./images/cards/clubs_6.png",
    isSelected: false,
    value: 6,
    points: 0
  },
  {
    id: 6,
    src: "./images/cards/clubs_7.png",
    isSelected: false,
    value: 7,
    points: 0
  },
  {
    id: 7,
    src: "./images/cards/clubs_8.png",
    isSelected: false,
    value: 8,
    points: 0
  },
  {
    id: 8,
    src: "./images/cards/clubs_9.png",
    isSelected: false,
    value: 9,
    points: 0
  },
  {
    id: 9,
    src: "./images/cards/clubs_10.png",
    isSelected: false,
    value: 10,
    points: 1
  },
  {
    id: 10,
    src: "./images/cards/clubs_A.png",
    isSelected: false,
    value: [1, 11],
    points: 1
  },
  {
    id: 11,
    src: "./images/cards/clubs_J.png",
    isSelected: false,
    value: 12,
    points: 1
  },
  {
    id: 12,
    src: "./images/cards/clubs_K.png",
    isSelected: false,
    value: 14,
    points: 1
  },
  {
    id: 13,
    src: "./images/cards/clubs_Q.png",
    isSelected: false,
    value: 13,
    points: 1
  },
  {
    id: 14,
    src: "./images/cards/diamonds_2.png",
    isSelected: false,
    value: 2,
    points: 0
  },
  {
    id: 15,
    src: "./images/cards/diamonds_3.png",
    isSelected: false,
    value: 3,
    points: 0
  },
  {
    id: 16,
    src: "./images/cards/diamonds_4.png",
    isSelected: false,
    value: 4,
    points: 0
  },
  {
    id: 17,
    src: "./images/cards/diamonds_5.png",
    isSelected: false,
    value: 5,
    points: 0
  },
  {
    id: 18,
    src: "./images/cards/diamonds_6.png",
    isSelected: false,
    value: 6,
    points: 0
  },
  {
    id: 19,
    src: "./images/cards/diamonds_7.png",
    isSelected: false,
    value: 7,
    points: 0
  },
  {
    id: 20,
    src: "./images/cards/diamonds_8.png",
    isSelected: false,
    value: 8,
    points: 0
  },
  {
    id: 21,
    src: "./images/cards/diamonds_9.png",
    isSelected: false,
    value: 9,
    points: 0
  },
  {
    id: 22,
    src: "./images/cards/diamonds_10.png",
    isSelected: false,
    value: 10,
    points: 2
  },
  {
    id: 23,
    src: "./images/cards/diamonds_A.png",
    isSelected: false,
    value: [1, 11],
    points: 1
  },
  {
    id: 24,
    src: "./images/cards/diamonds_J.png",
    isSelected: false,
    value: 12,
    points: 1
  },
  {
    id: 25,
    src: "./images/cards/diamonds_K.png",
    isSelected: false,
    value: 14,
    points: 1
  },
  {
    id: 26,
    src: "./images/cards/diamonds_Q.png",
    isSelected: false,
    value: 13,
    points: 1
  },
  {
    id: 27,
    src: "./images/cards/hearts_2.png",
    isSelected: false,
    value: 2,
    points: 0
  },
  {
    id: 28,
    src: "./images/cards/hearts_3.png",
    isSelected: false,
    value: 3,
    points: 0
  },
  {
    id: 29,
    src: "./images/cards/hearts_4.png",
    isSelected: false,
    value: 4,
    points: 0
  },
  {
    id: 30,
    src: "./images/cards/hearts_5.png",
    isSelected: false,
    value: 5,
    points: 0
  },
  {
    id: 31,
    src: "./images/cards/hearts_6.png",
    isSelected: false,
    value: 6,
    points: 0
  },
  {
    id: 32,
    src: "./images/cards/hearts_7.png",
    isSelected: false,
    value: 7,
    points: 0
  },
  {
    id: 33,
    src: "./images/cards/hearts_8.png",
    isSelected: false,
    value: 8,
    points: 0
  },
  {
    id: 34,
    src: "./images/cards/hearts_9.png",
    isSelected: false,
    value: 9,
    points: 0
  },
  {
    id: 35,
    src: "./images/cards/hearts_10.png",
    isSelected: false,
    value: 10,
    points: 1
  },
  {
    id: 36,
    src: "./images/cards/hearts_A.png",
    isSelected: false,
    value: [1, 11],
    points: 1
  },
  {
    id: 37,
    src: "./images/cards/hearts_J.png",
    isSelected: false,
    value: 12,
    points: 1
  },
  {
    id: 38,
    src: "./images/cards/hearts_K.png",
    isSelected: false,
    value: 14,
    points: 1
  },
  {
    id: 39,
    src: "./images/cards/hearts_Q.png",
    isSelected: false,
    value: 13,
    points: 1
  },
  {
    id: 40,
    src: "./images/cards/spades_2.png",
    isSelected: false,
    value: 2,
    points: 0
  },
  {
    id: 41,
    src: "./images/cards/spades_3.png",
    isSelected: false,
    value: 3,
    points: 0
  },
  {
    id: 42,
    src: "./images/cards/spades_4.png",
    isSelected: false,
    value: 4,
    points: 0
  },
  {
    id: 43,
    src: "./images/cards/spades_5.png",
    isSelected: false,
    value: 5,
    points: 0
  },
  {
    id: 44,
    src: "./images/cards/spades_6.png",
    isSelected: false,
    value: 6,
    points: 0
  },
  {
    id: 45,
    src: "./images/cards/spades_7.png",
    isSelected: false,
    value: 7,
    points: 0
  },
  {
    id: 46,
    src: "./images/cards/spades_8.png",
    isSelected: false,
    value: 8,
    points: 0
  },
  {
    id: 47,
    src: "./images/cards/spades_9.png",
    isSelected: false,
    value: 9,
    points: 0
  },
  {
    id: 48,
    src: "./images/cards/spades_10.png",
    isSelected: false,
    value: 10,
    points: 1
  },
  {
    id: 49,
    src: "./images/cards/spades_A.png",
    isSelected: false,
    value: [1, 11],
    points: 1
  },
  {
    id: 50,
    src: "./images/cards/spades_J.png",
    isSelected: false,
    value: 12,
    points: 1
  },
  {
    id: 51,
    src: "./images/cards/spades_K.png",
    isSelected: false,
    value: 14,
    points: 1
  },
  {
    id: 52,
    src: "./images/cards/spades_Q.png",
    isSelected: false,
    value: 13,
    points: 1
  }
];

export const CARD_BACKGROUND = "./images/background.jpeg"
export const NUMBER_OF_CARDS_IN_HAND = 6;
export const NUMBER_OF_CARDS_ON_TABLE = 4;